export const getImagePath = (path: string, landing = 'advancedMath'): string =>
  `https://static.uchi.ru/files/content-1-4/landings/${landing}/new/${path}`;
